<template lang="pug" src='./nav-mobile.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { showModal, toggleMenu, goToPayments } from '@/mixins'

export default {
  computed: {
    links () {
      return this.$router.options.routes
    },
    props () {
      return this.$store.state.app
    }
  },
  components: {
    Icon
  },
  mixins: [ showModal, toggleMenu, goToPayments ]
}
</script>



// WEBPACK FOOTER //
// nav-mobile.vue?33ce6117